import React from 'react';
import { connect } from 'react-redux'
import { Layout } from 'antd';
import 'antd/dist/antd.css';
import Footer from '../../components/DefaultDashboardTemplate/FooterCompoents';
import NavBarCompoents from '../../components/DefaultDashboardTemplate/NavBarCompoents';
import SystemModalContainer from '../DefaultModalTemplatContainer/SystemModalContainer'
const { Header, Content } = Layout;

class FormDeviseWorkContainer extends React.Component {

    render() {
        return (
            <Layout className="layout" style={{ minHeight: '100vh' }}>
                <SystemModalContainer/>

                <Header>
                    <NavBarCompoents />
                </Header>
                <Content style={{ padding: '0 50px', minHeight: '100vh' }}>
                    <div style={{ background: '#fff', padding: 24, minHeight: 280 }}>
                        {this.props.fromWorkMain}
                    </div>
                </Content>
                <Footer />
            </Layout>

        )
    }
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToPorps = (dispatch) => ({
})

export default connect(mapStateToProps, mapDispatchToPorps)(FormDeviseWorkContainer)


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/DefaultDeviseTemplateContainer/FormDeviseWorkContainer.jsx